import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { SLACK_OIDC_CONNECT } from 'constants/oAuthKeys';
import { WELCOME } from 'constants/routes';

import * as analytics from '../../../utilities/analytics';
import WelcomeModal from '../../welcome-modal';
import {
  ONBOARDING_INTRO_MODAL_CLICKED,
  ONBOARDING_INTRO_MODAL_VIEWED,
  VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_CLICKED,
  VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_DISMISSED,
  VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_VIEWED,
} from '../../../constants/events';
import { ROLLOUT_SLACK_IDENTITY_LINKS_ONBOARDING_MODAL } from '../../../../../shared/constants/featureFlag';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

const VIDEO_SHARE_PAGE = 'videoSharePage';
const ONBOARDING_SURVEY = 'onboardingSurvey';

const variantText = {
  [VIDEO_SHARE_PAGE]: {
    title: 'Welcome!',
    subtitle:
      'A Loom account has been created for you via Slack. Finish setting up your account to start sharing updates, feedback, and ideas with video messages.',
    buttonText: 'Finish account setup',
    dismissAltText: 'Back to the video',
  },
  [ONBOARDING_SURVEY]: {
    title: 'Welcome!',
    subtitle:
      "A Loom account has been created for you via Slack. Let's finish setting up your account to start sharing updates, feedback, and ideas with video messages.",
    buttonText: 'Finish account setup',
  },
};

const SlackIDLinkGetStartedModal = ({
  redirectOnClick,
  openByDefault = false,
  variant = VIDEO_SHARE_PAGE,
}) => {
  const onboardingComplete = useSelector(state => state.welcome.complete);

  const currentUser = useSelector(state => state.user.current);

  const isSlackIDLinkSignup =
    currentUser && currentUser.oauth?.[SLACK_OIDC_CONNECT] !== undefined;

  const [isOpen, setIsOpen] = useState(openByDefault);

  useEffect(() => {
    if (onboardingComplete || !isSlackIDLinkSignup) {
      return;
    }

    setIsOpen(openByDefault);

    if (openByDefault) {
      if (variant === ONBOARDING_SURVEY) {
        analytics.track(ONBOARDING_INTRO_MODAL_VIEWED);
      } else if (variant === VIDEO_SHARE_PAGE) {
        analytics.track(VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_VIEWED);
      }
    }
  }, [isSlackIDLinkSignup, onboardingComplete, openByDefault, variant]);
  const modalText = variantText[variant];

  if (onboardingComplete || !isSlackIDLinkSignup) {
    return null;
  }

  return (
    <FeatureFlaggedComponent
      flag={ROLLOUT_SLACK_IDENTITY_LINKS_ONBOARDING_MODAL}
      activationValues={[true]}
    >
      <div className="text:left">
        <WelcomeModal
          isOpen={isOpen}
          title={modalText.title}
          subtitle={modalText.subtitle}
          buttonText={modalText.buttonText}
          onButtonClick={() => {
            if (redirectOnClick) {
              analytics.track(VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_CLICKED);

              return (window.location.href = `${WELCOME}/?hideSlackIDLinkGetStartedModal=1`);
            }

            analytics.track(ONBOARDING_INTRO_MODAL_CLICKED);

            return setIsOpen(false);
          }}
          dismissText={modalText.dismissAltText}
          onDismissTextClick={() => {
            analytics.track(VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_DISMISSED);
            setIsOpen(false);
          }}
        />
      </div>
    </FeatureFlaggedComponent>
  );
};

export default SlackIDLinkGetStartedModal;
